
import Vue from 'vue'

import CKaggleTitle from './Title.vue'
export default Vue.extend({
  name: 'CKaggleSupport',
  components: { CKaggleTitle }

})
